import { render, staticRenderFns } from "./Ternary.vue?vue&type=template&id=63cea11c&"
import script from "./Ternary.vue?vue&type=script&lang=js&"
export * from "./Ternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports